export default __webpack_public_path__ + "static/media/hht2_ep4_speaking_03.8f35ef14.png";